import React, { PropsWithChildren } from 'react'
import Styles from './Section.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import cx from 'classnames'

export const Section = ({ children, title, className }: PropsWithChildren<{ title?: string; className?: string }>) => (
  <div className={cx(Styles.root, className)}>
    {title && <Heading level={3}>{title}</Heading>}
    {children}
  </div>
)
